/**
 * The name of an alert type, in the same words on every screen ("zone_capacity_warning" -> "Zone Capacity Warning").
 * Screens that show it in capitals do so with CSS, so the words never differ from one tab to the next.
 */
export function alertTypeLabel(alertType: string | null | undefined): string {
  if (!alertType) return 'Alert';
  return alertType
    .split('_')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
